import React from 'react';

function ProfessionalLogoDesigns() {
  const handleDesignClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('logo-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="logo-impact-section">
      <div className="container logo-impact-container">
        {/* Left Column: Content */}
        <div className="logo-impact-left">
          <div className="logo-impact-badge-row">
            <span className="logo-impact-badge">Logo Design & Branding</span>
            <div className="logo-impact-badge-line"></div>
          </div>

          <h2 className="logo-impact-title">
            <span className="text-red">Professional Logo Designs</span> That Make an Impact
          </h2>

          <p className="logo-impact-desc">
            We believe your logo is more than just an image. It is the visual core of your brand identity. We follow the best approach to provide you with professional logo design. Our team of experts understands your business and your target audience. We also consider your distinctive market position to craft the logo. Our company presents logos that act as strategic visual assets and are memorable and versatile.
          </p>

          <p className="logo-impact-desc">
            Our logo design agency maintains quality at every stage of our design process. We carefully take into account every detail, from the first conceptualization and sketching to the final digital execution. Our firm makes sure that your logo works best across all mediums, be it a tiny app icon or a large billboard. We select the appropriate color palettes and typography for your business and make sure that they resonate with your brand’s essence. At last, we deliver ready-to-use files in various formats. Our objective is to craft a distinctive and timeless design that looks best and communicates your brand’s message and values to set you apart in a crowded marketplace.
          </p>

          <button className="btn-logo-design-action" onClick={handleDesignClick}>
            Design my logo
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="logo-impact-right">
          <div className="logo-impact-img-wrapper">
            <img 
              src="/assets/images/logo-des/logo-img1.png" 
              alt="Professional Logo Designs That Make an Impact" 
              className="logo-impact-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProfessionalLogoDesigns;
